const differencesCategoryMapper = ({ notFoundInTime, userFound }) => {
  const type = notFoundInTime
    ? 'notFoundInTime'
    : userFound
    ? 'userFound'
    : null
  const categoryMapper = {
    notFoundInTime: 'cantFind',
    userFound: 'found',
  }
  return categoryMapper[type] || null
}

export default differencesCategoryMapper
